<template>
  <div class="left-bar">
      <div class="logo">
          <el-image
            style="height: 30px"
            src="https://guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com/cdn-office-website/scrm/logo2.png"
            fit="contain"></el-image>
      </div>
      <div class="nav-box">
          <el-menu 
            default-active="/customerInfo"
            class="el-menu-vertical-demo"  
            :collapse="isCollapse"
            background-color="#333333"
            text-color="#fff"
            active-text-color="#409eff"
            router
            :unique-opened ="true"
        >
        <el-menu-item index="/" v-if="false">
            <i class="arsenal_icon  arsenalhome"></i>
            <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/customerInfo">
            <i class="arsenal_icon arsenalkehu"></i>
            <span slot="title">线索池</span>
        </el-menu-item>
        <el-submenu index="2" v-if="false">
            <template slot="title">
            <i class="arsenal_icon arsenalxiansuo-daoyin"></i>
            <span slot="title">引流获客</span>
            </template>
            <!-- <el-submenu index="1-4">
                <template slot="title">企微活码</template>
                <el-menu-item index="/leadsSource/dynamicCodeStaff">员工活码</el-menu-item>
                <el-menu-item index="/leadsSource/dynamicCodeQun">群活码</el-menu-item>
            </el-submenu> -->
            <el-menu-item @click="gotoAskbotPlatform">对话机器人</el-menu-item>
            <el-menu-item index="/leadsSource/api">API导入线索</el-menu-item>
            <!-- <el-submenu index="1-4">
                <template slot="title">智能表单</template>
                <el-menu-item index="/workordertemlate">表单模板</el-menu-item>
                <el-menu-item index="/fieldmanagement">表单字段</el-menu-item>
            </el-submenu> -->
        </el-submenu>
        <el-submenu index="3">
            <template slot="title">
            <i class="arsenal_icon arsenalfenxiang"></i>
            <span slot="title">裂变获客</span>
            </template>
            <el-menu-item index="/massSend">群发任务</el-menu-item>
            <el-menu-item index="/leadsSource/businessCard">智能名片</el-menu-item>
            <el-menu-item index="/leadsSource/dynamicCodeStaff">企微活码</el-menu-item>
            <!-- <el-menu-item index="">客户朋友圈</el-menu-item> -->
        </el-submenu>
        <el-submenu index="4" v-if="false">
            <template slot="title">
            <i class="arsenal_icon arsenalrengongzhinengdanao"></i>
            <span slot="title">智能助手</span>
            </template>
            <el-menu-item index="/wechatSidebar">企微侧边栏</el-menu-item>
            <!-- <el-menu-item index="4-2">群机器人</el-menu-item>
            <el-menu-item index="4-3">客服机器人</el-menu-item> -->
        </el-submenu>
        <el-menu-item index="/material">
            <i class="arsenal_icon arsenalchangyong2"></i>
            <span slot="title">素材中心</span>
        </el-menu-item>
        <el-submenu index="5">
            <template slot="title">
            <i class="arsenal_icon arsenalshezhi"></i>
            <span slot="title">系统设置</span>
            </template>
            <!-- <el-menu-item index="/workordertemlate">线索模板</el-menu-item> -->
            <el-menu-item index="/defaultinfo">跟进状态</el-menu-item>
            <!-- <el-menu-item index="/leadsSetting/sourceName">来源名称</el-menu-item> -->
            <el-menu-item index="/leadsSetting/tag">标签管理</el-menu-item>
            <!-- <el-menu-item index="/leadsSetting/leadsAssign">线索分配</el-menu-item> -->
            <el-menu-item index="/companyInfo">公司管理</el-menu-item>
          <el-menu-item index="/staffManage">使用员工管理</el-menu-item>
          <!--  <el-menu-item index="/channel">渠道授权</el-menu-item>-->
            <el-menu-item index="/authorization">授权管理</el-menu-item>
        </el-submenu>
        <!-- <el-menu-item index="4">
            <i class="el-icon-setting"></i>
            <span slot="title">系统设置</span>
        </el-menu-item> -->
        </el-menu>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            isCollapse: false,
        }
    },
    methods:{
        gotoAskbotPlatform(){
            var tempwindow=window.open('_blank');
            tempwindow.location='https://open.askbot.cn';
        }
    }
}
</script>

<style scoped lang="less" scope>
.left-bar{
    width: 150px;
    height: 100vh;
    background-color: #333;
    .logo{
        width: auto;
        height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #409eff;
    }
    .nav-box{
        height: calc(100vh - 60px);
        overflow-x: hidden;
        overflow-y: auto;
        .el-menu-item{
            width: 150px !important;
            min-width: 150px !important;
        }
        .el-submenu{
            width: 150px !important;
            min-width: 150px !important;
            .el-submenu__title{

            }
        }
        .arsenal_icon{
            vertical-align: middle !important;
            margin-right: 5px !important;
            width: 24px !important;
            text-align: center !important;
            font-size: 18px !important;
        }
    }
}
</style>